import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  function Input({ label, error, hint, className, id, ...rest }, ref) {
    const inputId = id || rest.name;
    return (
      <div className="space-y-1">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-bold text-ink">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          {...rest}
          className={cn(
            'w-full px-4 py-2.5 rounded-xl border-2 outline-none transition',
            error ? 'border-red-400 focus:border-red-600' : 'border-gray-200 focus:border-navy',
            'bg-white text-ink placeholder:text-gray-400',
            className,
          )}
        />
        {error && <p className="text-red-600 text-xs">{error}</p>}
        {!error && hint && <p className="text-gray-500 text-xs">{hint}</p>}
      </div>
    );
  },
);
